var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c("v-card", { attrs: { width: "300" } }, [
        _c(
          "div",
          {
            staticClass:
              "header navy darken-2 secondary--text pb-10 d-flex flex-column align-center",
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.firebase_host + "/static/img/logo.png" },
              on: { dblclick: _vm.gotoLoginDeveloper },
            }),
          ]
        ),
        _vm._v(" "),
        !_vm.user_uid
          ? _c("div", [
              _vm.Config.STANDALONE
                ? _c(
                    "div",
                    {
                      staticClass: "px-8 py-5 d-flex flex-column align-center",
                    },
                    [
                      _c("h2", { staticClass: "mb-5" }, [
                        _vm._v("Accedi a ASTA LIVE"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "overlay-parent" },
                        [
                          _vm.sdk == "js-sdk"
                            ? _c("LoginSdkJs")
                            : _vm.sdk == "firebase-sdk"
                            ? _c("LoginSdkFb")
                            : _vm.sdk == "android-sdk"
                            ? _c("LoginSdkAndroid")
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isTcChecked
                            ? _c("div", {
                                staticClass: "overlay-child",
                                on: { click: _vm.showTcAlert },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Accetto" },
                            model: {
                              value: _vm.isTcChecked,
                              callback: function ($$v) {
                                _vm.isTcChecked = $$v
                              },
                              expression: "isTcChecked",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "ml-1",
                              attrs: {
                                target: "_blank",
                                href: _vm.Config.TERMINI_E_CONDIZIONI_LINK,
                              },
                            },
                            [
                              _vm._v(
                                "\n            Termini & Condizioni\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "px-8 py-5 d-flex flex-column align-center",
                    },
                    [
                      _c("h2", { staticClass: "mb-5" }, [
                        _vm._v("Non sei loggato"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n          Aggiorna la pagina (o esci e rientra) per rigenerare la sessione\n        "
                        ),
                      ]),
                    ]
                  ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }